import { Image } from '@spartacus/core';

export function getMediaByFormat(images: Image[], targetFormat: 'main' | 'thumbnail'): Image {

  return images?.find(({ format }) => format === targetFormat);
}
